









































import { Component, Vue } from 'vue-property-decorator'
import {
  GradeFrameController,
  FeatureController,
  AgencyController,
} from '@/services/request.service'
import DistributorEditor from './components/DistributorEditor.vue'
import FeatureEditor from './components/FeatureEditor.vue'
import FrameEditor from './components/FrameEditor.vue'

Component.registerHooks(['beforeRouteLeave'])

@Component({
  components: {
    DistributorEditor,
    FeatureEditor,
    FrameEditor,
  },
})
export default class EditDistributor extends Vue {
  private memberId = 0
  private agencyId = 0
  private distributor: any = {
    name: '',
    email: '',
    tel: '',
    address: '',
    introduction: '',
    contracts: [] as any,
  }
  private selectedFeatures = ['GROTHMNT', 'NOTIFICA']
  private frame: any = {
    frameIds: [],
  }
  private assessmentFrames: Array<any> = []
  private features: Array<any> = []
  private usedFrames: Array<any> = []
  private saved = false

  private created(): void {
    this.$route.meta.refresh = false
    this.getFeatures()
    this.getDistributor()
  }

  private beforeRouteLeave(to, from, next): void {
    if (!this.$store.state.forceBack) {
      if (!this.saved) {
        this.$confirm({
          title: this.$tc('common.reserveEdit'),
          onOk: () => {
            next()
          },
          onCancel: () => {
            next(false)
          },
        })
      } else {
        next()
      }
    } else {
      next()
    }
  }

  private getFeatures(): void {
    FeatureController.getFeatures()
      .then(res => {
        this.features = res.data
      })
      .catch(err => {
        console.error(err)
      })
  }

  private getDistributor(): void {
    const distributorId = parseInt(this.$route.params.distributorId, 10)
    AgencyController.detail(distributorId)
      .then(res => {
        const email = res.data.member.email
        const { name, tel, address, introduction } = res.data
        const contracts = res.data.resources.map(resource => {
          return {
            uid: resource.resourceId,
            url: resource.resourceUrl,
            name: resource.resourceName,
            status: 'done',
          }
        })
        this.distributor = {
          name,
          email,
          tel,
          address,
          introduction,
          contracts,
        }
        this.memberId = res.data.member?.memberId
        this.agencyId = res.data.agencyId
        this.selectedFeatures = res.data.features.map(feature => feature.featureCode)
        this.frame = {
          frameIds: res.data.frames.map(frame => frame.gradeFrameId),
        }
        this.usedFrames = res.data.frames
          .filter(frame => !frame.canDelete)
          .map(frame => frame.gradeFrameId)
      })
      .catch(err => {
        console.error(err)
      })
  }

  private complete(): void {
    let featureIds = [] as Array<number>
    this.features.forEach(feature => {
      if (this.selectedFeatures.includes(feature.featureCode)) {
        featureIds.push(feature.featureId)
      }
    })
    const { name, email, tel, address, introduction } = this.distributor
    const resourceIds = this.distributor.contracts.map((contract: any) => contract.uid)
    const frameIds = this.frame.frameIds
    const memberId = this.memberId
    const agencyId = this.agencyId
    const request = {
      agencyId,
      name,
      email,
      memberId,
      tel,
      address,
      resourceIds,
      introduction,
      featureIds,
      frameIds,
    }
    const distributorEditorForm = this.$refs.distributorEditor as any
    distributorEditorForm.$refs.distributorEditor.validate(valid => {
      if (valid) {
        if (this.selectedFeatures.includes('ASSSHEET')) {
          const frameEditorForm = this.$refs.frameEditor as any
          frameEditorForm.$refs.frameEditor.validate(valid => {
            if (valid) {
              AgencyController.update(request)
                .then(res => {
                  if (res.data && res.data.length) {
                    const frame = res.data.join('、')
                    this.$message.error(
                      this.$tc('distributorMgmt.usedFrame', res.data.length, { frame })
                    )
                  } else {
                    this.$message.success(this.$tc('common.saveSuccess'))
                    this.saved = true
                    this.$route.meta.refresh = true
                    this.$router.replace({ name: 'distributorMgmt' }).catch(err => {})
                  }
                })
                .catch(err => {
                  console.error(err)
                })
            } else {
              return false
            }
          })
        } else {
          AgencyController.update(request)
            .then(res => {
              this.$message.success(this.$tc('common.saveSuccess'))
              this.saved = true
              this.$route.meta.refresh = true
              this.$router.replace({ name: 'distributorMgmt' }).catch(err => {})
            })
            .catch(err => {
              console.error(err)
            })
        }
      } else {
        return false
      }
    })
  }

  private cancel(): void {
    this.$router.replace({ name: 'distributorMgmt' }).catch(err => {})
  }
}
